import { Injectable } from '@angular/core';

@Injectable()
export class AppConfigProvider {
  public ciBuildNumber = '13802';
  public termsUrl = 'https://www.pfizer.com/general/terms';
  public privacyPolicyUrl =
    'https://privacycenter.pfizer.com/en/app/surgicalproducts-us';
  public resourcesNewtonAssetId = '6fb31a52-000e-47e2-a21d-14b35a2a1404';
  public resourcesFilterNewtonAssetId = '717e6e9e-0235-45f9-93e9-0567c45a62d5';
  public trackingEventTypes = {
    mood: {
      id: 'mood',
      page: 'tracking-mood',
    },
    pain: {
      id: 'pain',
      page: 'tracking-pain',
    },
    infusions: {
      id: 'infusions',
      page: 'tracking-infusion',
    },
    example: {
      id: 'example',
      page: 'tracking-generic',
    },
  };
  public dateFormat = {
    DATE: 'MMM Do YYYY',
    DATE_TIME: 'MMM dd, YYYY h:mm a',
  };
  public remindersEventId = 'reminders';
  public recallAppCode = 'jetpack';
}
